module.exports = __webpack_public_path__ + "static/session_list-293843513321cec9d95a5963d6f6f58a.png";